import React from 'react'
import "./experience.scss";

const Experience = () => {

  const data = [
    {
      img: "d_01.png",
      title: "Transparent reporting",
      sub: "Real-time insights for informed decision making.",
    },
    {
      img: "d_02.png",
      title: "Dedicated Account Manager",
      sub: "Personalized support tailored to your business goals.",
    },
    {
      img: "d_03.png",
      title: "Advanced Software Solutions",
      sub: "Cutting-edge tools to power your digital infrastructure.",
    },
  ];
  return (
    <section className="experience">
      <div className="container">
        <div className="experience__header">
          <span className="experience__tagline">Premium Ecosystem</span>
          <h2 className="experience__title">
            Step Into the Future <span>of AI-Powered Trading</span>
          </h2>
          <div className="experience__underline"></div>
        </div>

        <div className="experience__grid">
          {data.map((item, index) => (
            <div className="experience__card" key={index}>
              <div className="experience__img-wrapper">
                <img src={require(`../../img/${item.img}`)} alt={item.title} />
              </div>
              <div className="experience__body">
                <h4 className="experience__card-title">{item.title}</h4>
                <p className="experience__card-sub">{item.sub}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Experience
